import styled, { css } from 'styled-components';

import { rem } from '../../../helpers';
import { Link } from '../../link';
import { Tooltip } from '../../Tooltip';
import { getColor } from '../Button.helpers';
import { buttonStyleMixin } from '../Button.styles';

import {
  getHeight,
  getOnHoverColor,
  handleJustifyContent,
  handleMargin,
} from './ButtonLink.helpers';
import { InnerButtonLinkStyledProps } from './ButtonLink.types';

const handleHoverAsHollow = (props: InnerButtonLinkStyledProps) => {
  const { disabled, theme } = props;
  const { interactions } = theme;

  if (interactions && !interactions.buttonHoverAsHollow && disabled) {
    return '';
  }

  return css`
    &:hover,
    &:focus {
      color: ${getOnHoverColor};
      svg {
        color: ${getOnHoverColor(props)};
      }
    }
  `;
};

const handleUnderline = ({ underline }: InnerButtonLinkStyledProps) => {
  if (!underline) {
    return null;
  }

  return css`
    display: flex;
  `;
};

const innerLinkOverload = (props: InnerButtonLinkStyledProps) => {
  const { $isNewUiEnabled } = props;

  if ($isNewUiEnabled) {
    return null;
  }

  return css`
    width: ${({ isFluid }: InnerButtonLinkStyledProps) =>
      isFluid ? null : 'fit-content'};

    font-weight: ${({ theme }) => theme.fonts.weight.mediumFont};

    svg {
      flex-shrink: 0;
      color: ${(props: InnerButtonLinkStyledProps) =>
        props.$iconColor || getColor(props)};
      max-height: ${rem(20)};
      max-width: ${rem(20)};
      transition-property: fill;
      transition-duration: 0.3s;
    }

    i.icon {
      height: ${rem(20)};
    }
    span {
      width: max-content;
    }
    > span {
      width: 100%;
    }

    ${getHeight};
    ${handleJustifyContent};
    ${handleMargin};

    ${handleUnderline};
    ${handleHoverAsHollow};
  `;
};

export const $InnerLinkStyled = styled(Link)<InnerButtonLinkStyledProps>`
  ${buttonStyleMixin};
  ${innerLinkOverload};
  &,
  &:hover {
    text-decoration: none;
  }
`;

export const $LockedTooltip = styled(Tooltip)`
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`;
